import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/landing-page/components/LandingPageInteractive.tsx");
